module.exports = __webpack_public_path__ + "static/media/roses.220d747c.jpg";